// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"589":"723d83f19b77d8d2","888":"ac78ac0bcf5c667d"}[chunkId] + ".css";
};